import { useState } from 'react'
import { Button } from './ui'

interface ClockInOutCardProps {
  isClocked: boolean
  onClockIn: () => void
  onClockOut: () => void
  lastClockTime?: string
}

export function ClockInOutCard({ isClocked, onClockIn, onClockOut, lastClockTime }: ClockInOutCardProps) {
  const [isLoading, setIsLoading] = useState(false)

  const handleAction = async () => {
    setIsLoading(true)
    try {
      if (isClocked) {
        await onClockOut()
      } else {
        await onClockIn()
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center mb-3">
            <div className={`w-3 h-3 rounded-full mr-3 ${isClocked ? 'bg-green-500' : 'bg-gray-400'}`} />
            <h3 className="text-lg font-semibold text-gray-900">
              {isClocked ? 'Clocked In' : 'Clocked Out'}
            </h3>
          </div>
          
          <p className="text-gray-600 mb-4">
            {isClocked 
              ? 'You are currently clocked in. Clock out when you finish working.'
              : 'You are currently clocked out. Clock in to start tracking your time.'
            }
          </p>
          
          {lastClockTime && (
            <p className="text-sm text-gray-500 mb-4">
              Last {isClocked ? 'clocked in' : 'clocked out'} at {lastClockTime}
            </p>
          )}
          
          <Button
            onClick={handleAction}
            disabled={isLoading}
            variant={isClocked ? 'secondary' : 'primary'}
            className="w-full sm:w-auto"
          >
            {isLoading ? 'Processing...' : (isClocked ? 'Clock Out' : 'Clock In')}
          </Button>
        </div>
        
        {/* Clock icon */}
        <div className="ml-4 p-3 bg-gray-50 rounded-lg">
          <svg className="w-8 h-8 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
      </div>
    </div>
  )
}